import { render, staticRenderFns } from "./zizhaoxuexiaoku.vue?vue&type=template&id=fc58cd40&scoped=true"
import script from "./zizhaoxuexiaoku.vue?vue&type=script&lang=js"
export * from "./zizhaoxuexiaoku.vue?vue&type=script&lang=js"
import style0 from "./zizhaoxuexiaoku.vue?vue&type=style&index=0&id=fc58cd40&prod&lang=less&scoped=true"
import style1 from "./zizhaoxuexiaoku.vue?vue&type=style&index=1&id=fc58cd40&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fc58cd40",
  null
  
)

export default component.exports